export { default, type RemovableTagProps } from './RemovableTag';
